

const initialState = {
  loading: false,
  data: {},      // since API returns an object (companyId, year, recommendations[])
  error: false,
};

const metricLevelInsightsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "METRIC_LEVEL_INSIGHTS_REQ":
      return {
        ...state,
        loading: true,
        error: false,
      };

    case "METRIC_LEVEL_INSIGHTS_SUC":
      return {
        ...state,
        loading: false,
        data: action.payload?.data || {}, // store the API "data" object
        error: false,
      };

    case "METRIC_LEVEL_INSIGHTS_ERR":
      return {
        ...state,
        loading: false,
        error: true,
      };

    default:
      return state;
  }
};

export default metricLevelInsightsReducer;
